import {observable, computed, action, autorun, extendObservable} from 'mobx';
import {computedAsync} from 'computed-async-mobx';
import pdfjs from 'pdfjs-dist/webpack';

export default class FileStore {
  @observable file;
  @observable pdf;

  pagesAsync = computedAsync([], async () => {
    const pdf = this.pdf;
    const result = [];
    for(let i = 1; i <= pdf.pdfInfo.numPages; i++) {
      const page = await pdf.getPage(i);
      result.push(page);
    }
    return result;
  });

  @computed get pages() {
    return this.pagesAsync.value;
  }

  @computed get name() {
    return this.file.name;
  };

  constructor(file) {
    extendObservable(this, { file });

    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      pdfjs.getDocument(fileReader.result).then(action(pdf => {
        extendObservable(this, { pdf });
      }));
    };
    fileReader.readAsArrayBuffer(file);
  }
}



// WEBPACK FOOTER //
// ./src/views/Imposer/FileStore.js